import { IconButton, Card, Typography, SxProps, Theme, Box } from '@mui/material';
import { Edit as EditIcon, Undo as UndoIcon } from '@mui/icons-material';
import { Customer } from 'shared/types/customer';
import { CustomerInput } from 'components/Quote/CustomerInput';
import { moneyFormatter } from 'shared/helpers';

const customerContainerStyles: SxProps<Theme> = { padding: '15px' };
const cardRootStyles: SxProps<Theme> = { overflow: 'unset' };
const customerInfoStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  maxWidth: '800px',
};
const inputContainerStyles: SxProps<Theme> = { width: '33%' };
const flexStyles: SxProps<Theme> = { display: 'flex' };

interface CustomerManagerProps {
  editingCustomer?: boolean;
  setEditingCustomer?: (val: boolean) => void;
  handleSetCustomer?: (customer: Customer) => void;
  customer: Customer;
}

export const CustomerManager = ({
  editingCustomer,
  setEditingCustomer,
  handleSetCustomer,
  customer,
}: CustomerManagerProps) => {
  const ttmSales = customer.ttm_sales_customer_number
    ? moneyFormatter.format(customer.ttm_sales_customer_number)
    : 'NOT AVAILABLE';
  return (
    <Card sx={{ ...customerContainerStyles, ...cardRootStyles }}>
      <Typography variant='h5'>Customer</Typography>
      <Box sx={customerInfoStyles}>
        <Box sx={inputContainerStyles}>
          {editingCustomer && handleSetCustomer && (
            <Box sx={flexStyles}>
              {customer.customer_number && setEditingCustomer && (
                <IconButton title='Keep current customer' onClick={() => setEditingCustomer(false)} size='large'>
                  <UndoIcon color='primary' />
                </IconButton>
              )}
              <CustomerInput onSelect={handleSetCustomer} />
            </Box>
          )}
          {!editingCustomer && customer && (
            <Box sx={flexStyles}>
              {setEditingCustomer && (
                <IconButton title='Change customer' onClick={() => setEditingCustomer(true)} size='large'>
                  <EditIcon color='secondary' />
                </IconButton>
              )}
              <p>{customer.customer_name || customer.customer_number}</p>
            </Box>
          )}
        </Box>

        <p>Customer tier : {customer?.customer_tier ?? '_'}</p>
        <p>TTM Sales: {ttmSales}</p>
      </Box>
    </Card>
  );
};
